module.exports = __webpack_public_path__ + "img/no-data.7914818d.png";